<div class="recaptcha-card" [class.recaptcha-verified]="verified()">
  <div class="recaptcha-left">
    <div
      class="recaptcha-checkbox"
      role="checkbox"
      tabindex="0"
      [attr.aria-checked]="verified()"
      aria-label="I am not a robot"
      (click)="onCheck()"
      (keydown.enter)="onCheck()"
      (keydown.space)="onCheck()"
    >
      @if (loading()) {
        <span class="recaptcha-spinner" aria-hidden="true"></span>
      } @else if (verified()) {
        <span class="recaptcha-checkmark" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 13l5 5L20 7" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      }
    </div>
    <span class="recaptcha-label">I'm not a robot</span>
  </div>

  <div class="recaptcha-right" aria-hidden="true">
    <div class="recaptcha-logo">
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 4 L60 20 L60 44 L32 60 L4 44 L4 20 Z" fill="#4A90D9" opacity="0.85"/>
        <path d="M32 14 L50 24 L50 40 L32 50 L14 40 L14 24 Z" fill="#fff" opacity="0.15"/>
        <text x="32" y="36" text-anchor="middle" fill="white"
              font-size="18" font-weight="bold" font-family="sans-serif">rC</text>
      </svg>
    </div>
    <div class="recaptcha-brand">MOCK-reCAPTCHA</div>
  </div>
</div>